module.exports = __webpack_public_path__ + "img/Qatar.b06cc584.svg";